import React from 'react'
import HeroServiziPage from '../Components/Hero/HeroServiziPage';
import Servizi from '../Components/Servizi/ServiziPage';

const heroData = {
    bgImg: 'images/hero-bg.jpg',
    bgShape: 'shape/hero-shape.png',
    sliderImages: [
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
        {
            img: 'images/hero-img.png',
        },
        {
            img: 'images/hero-img1.png',
        },
        {
            img: 'images/hero-img2.png',
        },
    ],
    title: "Trattamenti Viso",
    description: "<h4>Soluzioni estetiche avanzate per una pelle pi&ugrave; giovane, luminosa e rigenerata.</h4>"
        + "Pulizia profonda con DermaClear, lifting non invasivo ClearLift, laser Pixel CO2 e radiofrequenza per ringiovanire e tonificare. Trattamenti mirati e indolori per migliorare rughe, pori, cicatrici, pigmentazioni e smagliature, stimolando la produzione naturale di collagene."
};

const ServiziData = {
    img:"/images/dental-care.png",
    content2: `
        <h3>Le 3 Fasi del Trattamento DermaClear:</h3>
        <ol>
          <li><strong>DermaClear EXFO</strong><br>
          In questa fase, si utilizza una soluzione esfoliante con acido alfa idrossilico (AHA) per rimuovere le cellule morte e favorire il rinnovamento della pelle.</li>
          <li><strong>DermaClear CLEANSE</strong><br>
          Questa fase impiega una soluzione con acido salicilico (BHA), che penetra in profondit&agrave; per pulire la pelle e rimuovere impurit&agrave;, senza irritare.</li>
          <li><strong>DermaClear HYDRATE</strong><br>
          L&apos;ultima fase prevede l&apos;applicazione di un siero nutriente altamente concentrato, ricco di antiossidanti, che idrata la pelle e la rende pi&ugrave; morbida ed elastica.</li>
        </ol>

        <h3>Dettagli del Trattamento:</h3>
        <ul>
          <li><strong>Durata:</strong> Circa 30 minuti</li>
          <li><strong>Numero di Sedute:</strong> 1</li>
          <li><strong>Frequenza:</strong> Da ripetere ogni 3-4 settimane</li>
        </ul>

        <p>DermaClear &egrave; il trattamento ideale per chi cerca una pulizia profonda del viso, un miglioramento dell&apos;aspetto della pelle e un&apos;idratazione intensa senza interventi invasivi.</p>

        <br><br>

        <h2>Lifting non invasivo ClearLift</h2>
        <p><strong>ClearLift</strong> &egrave; un trattamento innovativo e non invasivo che offre un lifting viso senza bisturi, definito &quot;da pausa pranzo&quot; grazie alla sua velocit&agrave;, efficacia e totale assenza di dolore. Questo trattamento &egrave; ideale per chi desidera migliorare l&apos;aspetto del viso senza necessit&agrave; di anestesia, effetti collaterali o tempi di recupero.</p>

        <h3>Come Funziona ClearLift?</h3>
        <p>A differenza di altre tecnologie laser che agiscono termicamente per stimolare il collagene, ClearLift utilizza un&apos;energia focalizzata meccanicamente, penetrando negli strati pi&ugrave; profondi del derma fino a 3 mm senza danneggiare l&apos;epidermide. Questo stimola la produzione di nuovo collagene e rinforza il tessuto sottocutaneo, riducendo visibilmente le rughe e la perdita di tono della pelle.</p>

        <h3>Benefici del Trattamento:</h3>
        <ul>
          <li>Stimola la formazione di nuovo collagene</li>
          <li>Rende la pelle pi&ugrave; tonica e distesa</li>
          <li>Riduce le rughe e le linee sottili</li>
          <li>Trattamento indolore e senza effetti collaterali</li>
          <li>Adatto a tutti i tipi di pelle</li>
          <li>Senza bisogno di anestesia o tempi di recupero</li>
        </ul>

        <br><br>

        <h2>ClearSkin: Il Laser non ablativo</h2>
        <p><strong>ClearSkin</strong> &egrave; un laser non ablativo che utilizza un raffreddamento a contatto simultaneo per penetrare in profondit&agrave; nella pelle e stimolare la produzione di nuovo tessuto senza danneggiare l&apos;epidermide. Questo trattamento lascia la pelle pi&ugrave; giovane e sana, stimolando la guarigione e migliorando l&apos;aspetto generale della pelle.</p>

        <h3>Radiofrequenza Medica:</h3>
        <p>La <strong>Radiofrequenza medica</strong> &egrave; una tecnologia potente che stimola la produzione di collagene, tonificando e rassodando i tessuti di viso, collo e d&eacute;collet&eacute;. Con una frequenza di 40,68 MHz, questa tecnologia &egrave; tra le pi&ugrave; potenti e sicure, in grado di rigenerare la pelle in modo efficace e sicuro.</p>

        <h3>Dettagli del Trattamento ClearLift:</h3>
        <ul>
          <li><strong>Durata:</strong> Circa 30 minuti</li>
          <li><strong>Numero di sedute consigliate:</strong> 3 per risultati ottimali</li>
          <li><strong>Frequenza:</strong> Variabile a seconda delle esigenze del paziente</li>
        </ul>

        <p>ClearLift &egrave; il trattamento ideale per chi cerca un lifting viso naturale e non invasivo, con risultati visibili e duraturi.</p>

        <br><br>

        <h2>Pixel CO2: La Nuova Generazione del Laser CO2 per la Medicina Estetica</h2>
        <p>Il <strong>Pixel CO2</strong> rappresenta la nuova frontiera nella tecnologia laser per la medicina estetica, considerato il <em>gold standard</em> nel ringiovanimento della pelle grazie alla sua avanzata tecnologia di ablazione e stimolazione del collagene.</p>

        <h3>Come Funziona il Laser CO2?</h3>
        <p>Il <strong>Laser CO2</strong> agisce con una lunghezza d&apos;onda di 10.600 nm, che permette un elevato assorbimento dell&apos;acqua presente nei tessuti cutanei, creando una microablazione superficiale combinata con un effetto termico profondo. Questo processo stimola la produzione di collagene, migliorando visibilmente la texture della pelle.</p>
        <p>La tecnologia avanzata del laser CO2, eccitata da RF, offre una scansione laser precisa e computerizzata, che pu&ograve; essere utilizzata per trattamenti chirurgici multidisciplinari.</p>

        <h3>Tecnologia Pixel: Trattamenti Mirati e Precisi</h3>
        <p>Il <strong>Pixel CO2</strong> utilizza applicatori dedicati che distribuiscono l&apos;energia laser tramite un <strong>DOE (elemento ottico diffrattivo)</strong>. Questo processo pixelizza il raggio laser in microscopici punti, creando uno schema 9x9 o 7x7 che consente trattamenti termici pi&ugrave; efficaci, raggiungendo profondit&agrave; specifiche della pelle per risultati ottimali.</p>

        <h3>LiteScan: Trattamento Avanzato per Cicatrici e Smagliature</h3>
        <p>La tecnologia <strong>LiteScan</strong> &egrave; specificamente indicata per il trattamento di cicatrici e smagliature. &Egrave; anche ideale per il <em>skin resurfacing</em>, il trattamento di rughe, fibromi, cicatrici, verruche, cheratosi, neoformazioni benigne, condilomi, pigmentazioni cutanee e rinofima.</p>

        <h3>Indicazioni del Trattamento Pixel CO2:</h3>
        <ul>
          <li>Skin resurfacing</li>
          <li>Trattamento di rughe</li>
          <li>Fibromi</li>
          <li>Cicatrici</li>
          <li>Verruche</li>
          <li>Cheratosi</li>
          <li>Neoformazioni benigne</li>
          <li>Condilomi</li>
          <li>Pigmentazioni cutanee</li>
          <li>Rinofima</li>
          <li>Smagliature</li>
        </ul>

        <h3>Benefici del Trattamento Pixel CO2:</h3>
        <ul>
          <li><strong>Ringiovanimento della pelle:</strong> Stimola la produzione di collagene per una pelle pi&ugrave; giovane e tonica</li>
          <li><strong>Miglioramento della texture cutanea:</strong> Riduce rughe, cicatrici, smagliature e altre imperfezioni cutanee</li>
        </ul>
        <br><br><br><br>
    `,
    content1: `
        <h2>Pulizia viso medicale con DermaClear</h2>
        <p><strong>DermaClear</strong> &egrave; una piattaforma avanzata per la pulizia del viso, che utilizza una potente tecnologia di idrodermoabrasione suddivisa in tre fasi. Questo trattamento offre una pulizia profonda e nutriente della pelle, ottenendo risultati eccellenti sia come trattamento autonomo che come preparazione pre-estetica.</p>

        <h3>Benefici del Trattamento:</h3>
        <ul>
          <li>Rimuove macchie e cellule morte</li>
          <li>Migliora l&apos;assorbimento delle sostanze idratanti</li>
          <li>Stimola la produzione di collagene</li>
          <li>Riduce i pori</li>
          <li>Ossigena i tessuti</li>
        </ul>
    `,
};

const AboutPage = () => {
  return (
    <>
      <HeroServiziPage data={heroData} />
      <Servizi data={ServiziData} />
    </>
  )
}

export default AboutPage
